import { TFunction } from "i18next";
import { CustomDate } from "@/types/schemas/person";
import { isDateInPast } from "@/utils/date";

export const validationsHeatPump = (t: TFunction<"validations">) => {
  return {
    heatPumpBrand: (value: string | null) => !value && t("required"),
    heatPumpDate: (value: CustomDate | null) => (value === null || isDateInPast(value) ? null : t("invalidDate")),
  };
};
